var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { keys as defaultKeys, } from '@material-ui/core/styles/createBreakpoints';
var defaults = {
    keys: defaultKeys,
    values: {
        xs: 20,
        sm: 20,
        md: 42,
        lg: 72,
        xl: 72,
    },
    unit: 'rem',
};
export default (function (mw) {
    if (mw === void 0) { mw = defaults; }
    return (__assign(__assign({}, mw), { width: function (breakpoint) { return "" + mw.values[breakpoint] + mw.unit; } }));
});
//# sourceMappingURL=createMaxWidths.js.map